export interface Category {
  name: string;
  url: string;
  slug: string;
  icon: string;
  imageQuery: string;
  thumbUrl: string;
}

export const categories: Category[] = [
  {
    name: 'Shoes',
    url: 'https://kaspreadsheet.com/category-911-Shoes.html',
    slug: 'shoes',
    icon: 'ri-footprint-line',
    imageQuery: 'Stylish sneakers collection on clean white background, modern minimalist product photography, soft natural lighting, fashion footwear display, neutral tones, high detail editorial shot with subtle shadows and elegant composition',
    thumbUrl: 'https://readdy.ai/api/search-image?query=Minimalist%20sneaker%20on%20beige%20surface%20with%20soft%20studio%20light%20and%20clean%20neutral%20background%20product%20photography&width=120&height=120&seq=nav-shoes-thumb&orientation=squarish',
  },
  {
    name: 'Hoodies/Sweaters',
    url: 'https://kaspreadsheet.com/search-912/name/Shoes.html',
    slug: 'hoodies-sweaters',
    icon: 'ri-t-shirt-line',
    imageQuery: 'Premium quality hoodies and sweaters laid flat on light beige background, soft cozy textile photography, minimalist fashion display, warm neutral tones, clean aesthetic product shot with gentle shadows and harmonious arrangement',
    thumbUrl: 'https://readdy.ai/api/search-image?query=Cozy%20oversized%20hoodie%20on%20cream%20backdrop%20with%20soft%20diffused%20studio%20lighting%20and%20minimalist%20warm%20tone%20product%20photography&width=120&height=120&seq=nav-hoodies-thumb&orientation=squarish',
  },
  {
    name: 'T-Shirts',
    url: 'https://kaspreadsheet.com/search-913/name/Shoes.html',
    slug: 't-shirts',
    icon: 'ri-shirt-line',
    imageQuery: 'Collection of designer t-shirts on clean cream background, modern streetwear aesthetic, soft diffused lighting, minimalist product photography, muted earth tones, editorial fashion display with subtle texture details',
    thumbUrl: 'https://readdy.ai/api/search-image?query=Simple%20white%20t-shirt%20on%20light%20sand%20background%20with%20gentle%20natural%20window%20light%20and%20clean%20minimalist%20product%20display&width=120&height=120&seq=nav-tshirts-thumb&orientation=squarish',
  },
  {
    name: 'Jackets',
    url: 'https://kaspreadsheet.com/search-914/name/Shoes.html',
    slug: 'jackets',
    icon: 'ri-t-shirt-2-line',
    imageQuery: 'Premium jackets and outerwear display on soft neutral background, modern fashion photography, clean minimalist aesthetic, soft natural light, warm taupe and beige tones, elegant editorial product shot with refined composition',
    thumbUrl: 'https://readdy.ai/api/search-image?query=Stylish%20bomber%20jacket%20on%20warm%20oatmeal%20colored%20surface%20with%20soft%20directional%20light%20and%20clean%20modern%20product%20photography%20aesthetic&width=120&height=120&seq=nav-jackets-thumb&orientation=squarish',
  },
  {
    name: 'Pants/Shorts',
    url: 'https://kaspreadsheet.com/search-915/name/Shoes.html',
    slug: 'pants-shorts',
    icon: 'ri-pantone-line',
    imageQuery: 'Designer pants and shorts laid flat on light warm background, contemporary fashion photography, soft overhead lighting, minimalist display, neutral earthy colors, clean high detail editorial shot with gentle shadows',
    thumbUrl: 'https://readdy.ai/api/search-image?query=Casual%20cargo%20pants%20folded%20on%20ivory%20linen%20surface%20with%20diffused%20natural%20light%20and%20contemporary%20minimalist%20product%20photography&width=120&height=120&seq=nav-pants-thumb&orientation=squarish',
  },
  {
    name: 'Headwear',
    url: 'https://kaspreadsheet.com/search-916/name/Shoes.html',
    slug: 'headwear',
    icon: 'ri-customer-service-line',
    imageQuery: 'Stylish caps and headwear collection on clean white surface, modern accessory photography, soft natural lighting, minimalist aesthetic, muted tones, high detail product display with refined shadows and balanced composition',
    thumbUrl: 'https://readdy.ai/api/search-image?query=Baseball%20cap%20on%20light%20stone%20colored%20platform%20with%20soft%20rim%20lighting%20and%20clean%20minimalist%20product%20detail%20photography&width=120&height=120&seq=nav-headwear-thumb&orientation=squarish',
  },
  {
    name: 'Sets',
    url: 'https://kaspreadsheet.com/search-917/name/Shoes.html',
    slug: 'sets',
    icon: 'ri-stack-line',
    imageQuery: 'Matching clothing sets arranged on light cream background, coordinated fashion photography, soft studio lighting, minimalist aesthetic, warm beige tones, clean editorial display with elegant arrangement and subtle shadows',
    thumbUrl: 'https://readdy.ai/api/search-image?query=Coordinated%20outfit%20set%20on%20warm%20ecru%20surface%20with%20balanced%20studio%20lighting%20and%20refined%20minimalist%20product%20arrangement%20photography&width=120&height=120&seq=nav-sets-thumb&orientation=squarish',
  },
  {
    name: 'Underwear/Underpants',
    url: 'https://kaspreadsheet.com/search-918/name/Shoes.html',
    slug: 'underwear',
    icon: 'ri-checkbox-blank-line',
    imageQuery: 'Premium underwear collection on soft neutral background, clean minimalist product photography, soft diffused lighting, subtle warm tones, refined aesthetic display with gentle shadows and elegant composition',
    thumbUrl: 'https://readdy.ai/api/search-image?query=Premium%20cotton%20underwear%20pack%20on%20light%20greige%20textured%20surface%20with%20soft%20even%20lighting%20and%20clean%20minimal%20product%20photography&width=120&height=120&seq=nav-underwear-thumb&orientation=squarish',
  },
  {
    name: 'Jersey',
    url: 'https://kaspreadsheet.com/search-919/name/Shoes.html',
    slug: 'jersey',
    icon: 'ri-vip-crown-line',
    imageQuery: 'Sports jerseys collection displayed on clean light background, modern athletic wear photography, soft natural lighting, minimalist aesthetic, neutral tones, high detail editorial product shot with balanced composition',
    thumbUrl: 'https://readdy.ai/api/search-image?query=Football%20jersey%20on%20warm%20off%20white%20surface%20with%20soft%20side%20lighting%20and%20clean%20athletic%20product%20photography%20minimalist%20style&width=120&height=120&seq=nav-jersey-thumb&orientation=squarish',
  },
  {
    name: 'Accessories',
    url: 'https://kaspreadsheet.com/search-920/name/Shoes.html',
    slug: 'accessories',
    icon: 'ri-glasses-line',
    imageQuery: 'Fashion accessories collection on soft cream background, modern minimalist product photography, soft studio lighting, warm neutral tones, elegant display, high detail editorial composition with subtle refined shadows',
    thumbUrl: 'https://readdy.ai/api/search-image?query=Sunglasses%20and%20watch%20on%20pale%20sand%20colored%20surface%20with%20soft%20natural%20light%20and%20refined%20minimalist%20accessory%20product%20photography&width=120&height=120&seq=nav-accessories-thumb&orientation=squarish',
  },
  {
    name: 'Bags',
    url: 'https://kaspreadsheet.com/search-921/name/Shoes.html',
    slug: 'bags',
    icon: 'ri-handbag-line',
    imageQuery: 'Designer bags and backpacks on clean light background, modern luxury accessory photography, soft natural lighting, minimalist aesthetic, warm beige tones, high detail editorial product shot with elegant shadows',
    thumbUrl: 'https://readdy.ai/api/search-image?query=Leather%20crossbody%20bag%20on%20warm%20neutral%20surface%20with%20soft%20diffused%20light%20and%20elegant%20minimal%20product%20photography%20aesthetic&width=120&height=120&seq=nav-bags-thumb&orientation=squarish',
  },
  {
    name: 'Belts',
    url: 'https://kaspreadsheet.com/search-922/name/Shoes.html',
    slug: 'belts',
    icon: 'ri-link',
    imageQuery: 'Premium leather belts collection on soft neutral background, modern accessory photography, soft diffused lighting, minimalist aesthetic, warm earthy tones, clean high detail product display with subtle shadows',
    thumbUrl: 'https://readdy.ai/api/search-image?query=Designer%20leather%20belt%20coiled%20on%20light%20warm%20grey%20surface%20with%20soft%20angled%20lighting%20and%20clean%20luxury%20product%20detail%20photography&width=120&height=120&seq=nav-belts-thumb&orientation=squarish',
  },
  {
    name: 'Perfumes',
    url: 'https://kaspreadsheet.com/search-923/name/Shoes.html',
    slug: 'perfumes',
    icon: 'ri-contrast-drop-line',
    imageQuery: 'Elegant perfume bottles on soft cream background, luxury fragrance photography, soft natural lighting, minimalist aesthetic, warm golden tones, refined editorial product shot with delicate shadows and sophisticated composition',
    thumbUrl: 'https://readdy.ai/api/search-image?query=Elegant%20perfume%20bottle%20on%20soft%20cream%20surface%20with%20warm%20rim%20light%20and%20refined%20luxury%20product%20photography%20minimal%20aesthetic&width=120&height=120&seq=nav-perfumes-thumb&orientation=squarish',
  },
  {
    name: 'Other Stuff',
    url: 'https://kaspreadsheet.com/search-924/name/Shoes.html',
    slug: 'other-stuff',
    icon: 'ri-more-line',
    imageQuery: 'Various lifestyle products collection on clean light background, modern eclectic product photography, soft natural lighting, minimalist aesthetic, neutral warm tones, high detail editorial display with balanced composition',
    thumbUrl: 'https://readdy.ai/api/search-image?query=Assorted%20lifestyle%20items%20on%20light%20beige%20surface%20with%20soft%20ambient%20light%20and%20clean%20curated%20product%20flatlay%20photography%20aesthetic&width=120&height=120&seq=nav-other-thumb&orientation=squarish',
  },
];

export const mainSiteUrl = 'https://kaspreadsheet.com';